import styled from '@emotion/styled'
import type { FC } from 'react'

import Divider from '@segment/matcha/components/Divider'

import * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import { Hyperlink } from '@segment/matcha/recipes/RichText'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

const link = {
  text: `past webinars.`,
  url: `#past-webinars`,
}

interface NoResultsProps {
  heading: string
  description: string
}

const NoResults: FC<NoResultsProps> = ({ heading, description }) => {
  const pageConfig = usePageConfig()
  return (
    <SectionBase variant="noCopy">
      <Section.Contents>
        <CopyText.Heading variant="h4" tag="p">
          {heading}
        </CopyText.Heading>
        <CopyText.Description variant="pMedium" tag="p">
          {description}
          <Hyperlink size="small" tag="a" href={getAbsoluteUrl(link.url, pageConfig)}>
            {link.text}
          </Hyperlink>
        </CopyText.Description>
        <DividerWrapper>
          <Divider />
        </DividerWrapper>
      </Section.Contents>
    </SectionBase>
  )
}

const DividerWrapper = styled.div`
  margin-top: 40px;
`

export default NoResults
